import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';

export const cardCss = css({
  padding: '16px 16px 24px',
  width: 327,
  [MediaQueries.lgAndUp]: {
    padding: '32px 32px 24px',
  },
  [MediaQueries.xl]: {
    width: 359,
  },
});

export const headlineCss = css(typography.effra28, {
  fontWeight: fontWeights.regular,
  color: colorsPalette.black,
  marginBottom: 16,
});

export const descriptionCss = css(typography.effra16, {
  color: colorsPalette.black,
  marginBottom: 27,
});

export const ctaLinkCss = css({
  marginBottom: 10,
});
